import { mapActions, mapGetters } from 'vuex';

const InvokeSceneMixin = {
  computed: {
    ...mapGetters([
      'getSceneVarsBySceneId',
      'getVarById',
      'getActorById',
    ]),
  },
  methods: {
    ...mapActions([
      'setVarsValue',
    ]),
    invokeScene(sceneId) {
      this.$log.info('scene invoked', sceneId);
      this.getSceneVarsBySceneId(sceneId).forEach((sceneVar) => {
        const varItem = this.getVarById(sceneVar.varId);
        let valueToSet = sceneVar.value;
        let valueToCompare = varItem.value;
        const actor = this.getActorById(varItem.actorId);
        if (actor.targetActorId && actor.component === 'ButtonSwitch') {
          const targetActor = this.getActorById(actor.targetActorId);
          if (targetActor.singleVarId) {
            const targetVar = this.getVarById(targetActor.singleVarId);
            if (targetVar.type === 'BOOL') {
              valueToCompare = targetVar.value;
              valueToSet = true;
            } else {
              return;
            }
          } else {
            return;
          }
        }
        if (sceneVar.value !== valueToCompare) {
          this.setVarsValue({ varItem: this.getVarById(sceneVar.varId), value: valueToSet });
        }
      });
    },
  },
};

export default InvokeSceneMixin;
